import React from 'react';
export interface MediaQueryListEvent {
    matches: boolean;
}

export interface MuiMediaQueryList {
    matches: boolean;
    addListener: (listener: MediaQueryListListener) => void;
    removeListener: (listener: MediaQueryListListener) => void;
}
  
export type MediaQueryListListener = (event: MediaQueryListEvent) => void;
  
export interface Options {
    defaultMatches?: boolean;
}
  
  
export default function useMediaQuery(queryInput: string, options: Options = {}) {
  const query = queryInput.replace('@media ', '');
  const { defaultMatches = false } = options;

  const [matches, setMatches] = React.useState(() => {
    
    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });

  React.useEffect(() => {
    
    const queryList = window.matchMedia(query);
    setMatches(queryList.matches);

    function handleMatchesChange(event: MediaQueryListEvent) {
      setMatches(event.matches);
    }

    if (queryList.addEventListener !== undefined && (typeof queryList.addEventListener === 'function')) {

        queryList.addEventListener('change', handleMatchesChange);

    } else {
        queryList.addListener(handleMatchesChange);
    }

    return () => {
        if ( queryList.removeEventListener !== undefined && (typeof  queryList.removeEventListener === 'function')) {
            queryList.removeEventListener('change', handleMatchesChange);
        } else {
            queryList.removeListener(handleMatchesChange);
        }

    };
  }, [query]);

  return matches;
}


// /* Extra small devices (phones, 600px and down) */
// @media only screen and (max-width: 600px) {...} 

// /* Small devices (portrait tablets and large phones, 600px and up) */
// @media only screen and (min-width: 600px) {...} 

// /* Medium devices (landscape tablets, 76px and up) */
// @media only screen and (min-width: 768px) {...} 

// /* Large devices (laptops/desktops, 992px and up) */
// @media only screen and (min-width: 992px) {...} 

// /* Extra large devices (large laptops and desktops, 1200px and up) */
// @media only screen and (min-width: 1200px) {...}

export const SMBREAK = '(max-width: 600px)';
export const XSBREAK = '(min-width: 601px)';
export const MBREAK = '(min-width: 768px)';
export const LBREAK = '(min-width: 992px)';
export const XLBREAK = '(min-width: 1200px)';

export const XLPRINT = 'print';